import React, { useState } from "react";
import axios from 'axios';

import "./ChangePasswordModal.css";
import { API_BASE_URL} from "../../Variables";

import showIcon from "../../assets/images/show.svg";
import hideIcon from "../../assets/images/hide.svg";

/**
 * Change Password Modal, used to update the user's password in Settings page
 * @param {*} onClose - Function to close the modal
 * @returns - JSX element
 */
function ChangePasswordModal( {onClose} ) {
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const token = localStorage.getItem('token');

  const validatePassword = (password) => {
    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
    return passwordRegex.test(password);
  };

  const handlePasswordChange = async (e) => {
    e.preventDefault();
    if (newPassword !== confirmPassword) {
      setError("New passwords don't match");
      return;
    }

    if (!validatePassword(newPassword)) {
      setError('New password must be at least 8 characters long and contain at least one uppercase letter, one lowercase letter, one number, and one special character');
      return;
    }

    try {
      const response = await axios.put(
        `${API_BASE_URL}/settings/password`,
        { currentPassword, newPassword },
        { headers: { 'Authorization': `Bearer ${token}` } }
      );
      setSuccess(response.data.message);
      setError('');
      setCurrentPassword('');
      setNewPassword('');
      setConfirmPassword('');
      setTimeout(onClose, 2000);
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to update password');
    }
  };

  return (
    <div className="modal-overlay">
      <div className="change-modal">
        <h2>Change Password</h2>
        
        <form onSubmit={handlePasswordChange}>
          <div className="form-input">
            <label>Current Password:</label>
            <div className="password-input">
              <input type={showCurrentPassword ? 'text' : 'password'} value={currentPassword}
                onChange={(e) => setCurrentPassword(e.target.value)} required/>
              <img src={showCurrentPassword ? hideIcon : showIcon} alt="Show password" 
                className="password-visibility" onClick={() => setShowCurrentPassword(!showCurrentPassword)}/>
            </div>
          </div>
          
          <div className="form-input">
            <label>New Password:</label>
            <div className="password-input">
              <input type={showNewPassword ? 'text' : 'password'} value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)} required/>
              <img src={showNewPassword ? hideIcon : showIcon} alt="Show password" 
                className="password-visibility" onClick={() => setShowNewPassword(!showNewPassword)}/>
            </div>
          </div>

          <div className="form-input">
            <label> Confirm New Password:</label>
            <div className="password-input">
              <input type={showConfirmPassword ? 'text' : 'password'} value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)} required/>
              <img src={showConfirmPassword ? hideIcon : showIcon} alt="Show password" 
                className="password-visibility" onClick={() => setShowConfirmPassword(!showConfirmPassword)}/>
            </div>
          </div>

          {success && <p className="success">{success}</p>}
          {error && <p className="error">{error}</p>}

          <button type="submit" className="tertiary-button">Update Password</button>
          <button type="button" onClick={onClose} className="secondary-button">Cancel</button>
        </form>
      </div>
    </div>
  );
}

export default ChangePasswordModal;